export enum STAGE_STATUS {
  STARTED = "STARTED",
  COMPLETED = "COMPLETED",
  SCHEDULED = "SCHEDULED",
}
